import * as React from "react";
import { INotification } from "~/containers/Notifications/NotificationsContainer";
import Notification from "./Notification";

interface IProps {
  notifications: INotification[];
}

export default class NotificationList extends React.Component<IProps> {
  public render() {
    return this.props.notifications.map(notification => (
      <Notification key={notification.key} notification={notification} />
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationList.tsx